export enum PubSubTopic {
  ManagementJobAdded = 'management-job.added',
  BigQueryJobAdded = 'big-query-job.added',
  BigQueryUploadJobAdded = 'big-query-upload-job.added',
  ReportingJobAdded = 'reporting-job.added',

  // Notifications
  AppointmentAdd = 'appointment.add',
  AppointmentCancelled = 'appointment.cancelled',
  AppointmentRescheduled = 'appointment.rescheduled',

  // Practice Migrations
  PracticeMigrationMigrateJob = 'practice-migration.destination.migrate',
  PracticeMigrationSyncJob = 'practice-migration.source.sync',
  PracticeMigrationMergeConflictJob = 'practice-migration.destination.merge-conflict',

  // Sync Patient Phone Numbers
  PatientUpdate = 'patient.update',

  // Cloud SQL
  CloudSqlInstanceEvent = 'cloudsql.instance.event',

  // Typesense
  TypesenseSync = 'typesense.sync',
}
